import React from "react";

import { DEAL_TYPE_KEYS, ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealLaScKeyCommentCreatorTable from "./components/DealLaScKeyCommentCreatorTable/DealLaScKeyCommentCreatorTable";
import { DEAL_LA_SC_KEY_COMMENT_GROUP_TABLE_LAYOUT } from "./constants/dealLaScKeyCommentGroupTableLayout";
import * as S from "./DealLaScKeyCommentGroupTable.style";

const { groupTableKey, tableList } = DEAL_LA_SC_KEY_COMMENT_GROUP_TABLE_LAYOUT;
const groupTableIndex = 5;

const ARTICLE_SECTION = ENTRY_DATA_SECTION_KEYS.dealsLaSc;

const DealLaScKeyCommentGroupTable = () => {
  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  const { register } = useScroll();
  const { tableCount } = useGetNumberOfTable();
  const articleSection = ARTICLE_SECTION;

  const { checkDisableEdit } = useCanEditGroupTable();
  if (isMergeAndAcquisition) return null;
  if (currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation)) {
    return null;
  }
  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register("Key Comment (New)")}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
        titleColor="#11AC45"
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {newArrayToCountValue(tableCount(groupTableKey)).map(
          (_, tableIndex) => (
            <div key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}>
              {tableList.map(({ tableKey, groupShellList }) => (
                <DealLaScKeyCommentCreatorTable
                  key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
                  tableKey={tableKey}
                  groupShellList={groupShellList}
                  groupTableKey={groupTableKey}
                  groupTableIndex={groupTableIndex}
                  tableIndex={tableIndex}
                  tableCount={tableCount(groupTableKey)}
                />
              ))}
            </div>
          ),
        )}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealLaScKeyCommentGroupTable;
